var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallMissed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.5,18h-5a.5.5,0,0,1-.474-.342L133.14,15h-6.28l-.886,2.658A.5.5,0,0,1,125.5,18h-5a.5.5,0,0,1-.5-.5l.023-2.67a2.6,2.6,0,0,1,1.323-2.258C122.611,11.853,125.141,11,130,11s7.387.853,8.653,1.567a2.607,2.607,0,0,1,1.324,2.266L140,17.5a.5.5,0,0,1-.5.5Zm-4.64-1H139l-.019-2.163a1.609,1.609,0,0,0-.816-1.4C137,12.782,134.64,12,130,12s-7,.782-8.163,1.439a1.6,1.6,0,0,0-.814,1.392L121,17h4.136l.886-2.658A.5.5,0,0,1,126.5,14h7a.5.5,0,0,1,.474.342Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.854,2.146a.5.5,0,0,0-.708,0L130.7,7.589a1.018,1.018,0,0,1-1.408,0L124.707,3H128.5a.5.5,0,0,0,0-1h-5a.5.5,0,0,0-.5.5v5a.5.5,0,0,0,1,0V3.707L128.589,8.3a1.994,1.994,0,0,0,2.822,0l5.443-5.442A.5.5,0,0,0,136.854,2.146Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallMissed);
export default __webpack_public_path__ + "static/media/Call_Missed.d6d83669047a3572c2f6dede2cb2f5dd.svg";
export { ForwardRef as ReactComponent };